// 调试API
import request from '@/utils/request/index';

export function getInfo() {
    return request({
        url: '/users/current-user',
        method: 'GET'
    });
}

export function getUserList(parameter) {
    return request({
        url: '/users/page',
        method: 'GET',
        params: parameter
    });
}

export function getUserById(id) {
    return request({
        url: `/users/${id}`,
        method: 'GET'
    });
}

export function addUser(params) {
    return request({
        url: '/users',
        method: 'POST',
        data: params
    });
}

export function updateUser(id, params) {
    return request({
        url: `/users/${id}`,
        method: 'PUT',
        data: params
    });
}

export function deleteUser(id) {
    return request({
        url: `/users/${id}`,
        method: 'DELETE'
    });
}

export function getRoleList(parameter) {
    return request({
        url: '/roles/page',
        method: 'GET',
        params: parameter
    });
}

export function listAvailableRoles() {
    return request({
        url: '/roles',
        method: 'GET',
        params: {
            status: 'Enabled'
        }
    });
}

export function getRoleById(id) {
    return request({
        url: `/roles/${id}`,
        method: 'GET'
    });
}

export function listApiPermissions() {
    return request({
        url: `/permissions/api`,
        method: 'GET'
    });
}

export function listDataPermissions() {
    return request({
        url: `/permissions/data`,
        method: 'GET'
    });
}

export function synchronizePermissions() {
    return request({
        url: '/permissions/sync',
        method: 'POST'
    });
}

export function addRole(params) {
    return request({
        url: '/roles',
        method: 'POST',
        data: params
    });
}

export function updateRole(roleId, params) {
    return request({
        url: `/roles/${roleId}`,
        method: 'PUT',
        data: params
    });
}

export function deleteRole(roleId) {
    return request({
        url: `/roles/${roleId}`,
        method: 'DELETE'
    });
}

export function listGlobalRoleUserTypes() {
    return request({
        url: '/roles/user-types',
        method: 'GET'
    });
}

export function pagePermissions(parameter) {
    return request({
        url: '/permissions/page',
        method: 'GET',
        params: parameter
    });
}

export function pageDataPermissions(parameter) {
    return request({
        url: '/permissions/data/page',
        method: 'GET',
        params: parameter
    });
}
